import { useMemo, useState } from 'react';
import { Button, TYPE } from '@common/Button/Button';
import { useTranslation } from 'next-i18next';
import { useBreakpoints } from '@hooks/useBreakpoints';
import { WidenImage } from '@common/Widen/WidenImage';
import Locale from '@formatjs/intl-locale';
import { useRouter } from 'next/router';
import { Modal, ModalVariant } from '@common/Modal/Modal';

export const GuideThroughConfiguratorBox = () => {
  const { t } = useTranslation('product/echainBuyBox');
  const { lg } = useBreakpoints();
  const [isMobileHintModalVisible, setIsMobileHintModalVisible] = useState(false);

  const { locale } = useRouter();

  const languageCultureQuery = useMemo(() => {
    if (!locale) {
      return '';
    }
    const localeObj = new Locale(locale);
    if (!localeObj.region) {
      // language is available but region isn't
      return `&l=${localeObj.language}`;
    }
    // query with only region has no effect, so it is unnecessary
    return `&l=${localeObj.language}&c=${localeObj.region}`;
  }, [locale]);

  return (
    <div
      data-testid="guide-trough-configurator-box"
      className="bg-white ml-2 mr-2 mb-8 border border-gray-200 p-8 grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-3"
    >
      <div className="col-span-2">
        <h3 className="mb-4 text-sm font-bold">{t('ECHAIN_PRODUCT_PAGE.GUIDE_TROUGH.CONFIGURATOR_HEADLINE')}</h3>
        <p className="mb-8 text-sm">{t('ECHAIN_PRODUCT_PAGE.GUIDE_TROUGH.CONFIGURATOR_TEXT')}</p>
        {lg ? (
          <Button
            href={`/iProSvc/appredirect.aspx?app=koplaeke${languageCultureQuery}`}
            external
            text={t('ECHAIN_PRODUCT_PAGE.GUIDE_TROUGH.OPEN_CONFIGURATOR')}
            className="md:w-auto rounded mb-7"
          />
        ) : (
          <>
            <Button
              type={TYPE.SECONDARY}
              onClick={() => setIsMobileHintModalVisible(true)}
              text={t('ECHAIN_PRODUCT_PAGE.GUIDE_TROUGH.OPEN_CONFIGURATOR')}
              className="md:w-auto mb-7 opacity-25"
            />
            <Modal
              variant={ModalVariant.ALERT}
              visible={isMobileHintModalVisible}
              onClose={() => setIsMobileHintModalVisible(false)}
              headline={t('ECHAIN_PRODUCT_PAGE.GUIDE_TROUGH.CONFIGURATOR_MOBILE_USER_HINT_TITLE')}
            >
              {t('ECHAIN_PRODUCT_PAGE.GUIDE_TROUGH.CONFIGURATOR_MOBILE_USER_HINT')}
            </Modal>
          </>
        )}
      </div>
      <div className="w-full">
        <WidenImage
          shortCode="3hkc3e92br"
          filename="festpunktmodul%2C%20neu%20ployme.webp"
          layout="responsive"
          width={200}
          height={200}
        />
      </div>
    </div>
  );
};
